import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Menu from "./Menu"; // Import the Menu component
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";

import "../../my_styles/myStyles.css";
import landing_page_style from "../../my_styles/landing_page_styles.css";

import image_1 from "./assets/image_1.jpg";
import image_2 from "./assets/image_2.jpg";
import image_3 from "./assets/image_3.jpg";

import Table from "react-bootstrap/Table";
import Footer from "./Footer";
import { main_link } from "../../Connection/Connection";
import useFetch from "../../Fetch_Folder/useFetch";

import { useState, useEffect } from "react";

import BookCut from "../BookCut";
import Spinner from "react-bootstrap/Spinner";
//
const MainPage = () => {
  const style = {};

  const {
    error: errorCuts,
    isLoading: isLoadingCuts,
    data: cuts,
  } = useFetch(`${main_link}visitorShowCut`);

  const {
    error,
    isLoading: isLoadingSchedules,
    data: schedules,
  } = useFetch(`${main_link}scheduleIndexVisitor`);

  function groupTimeSlots(times) {
    const grouped = [];
    let start = times[0];
    let end = times[0];

    for (let i = 1; i < times.length; i++) {
      const prevTime = new Date(`1970/01/01 ${times[i - 1]}`);
      const currTime = new Date(`1970/01/01 ${times[i]}`);
      const diff = (currTime - prevTime) / 60000; // Difference in minutes

      if (diff > 30) {
        if (start === end) {
          grouped.push(start);
        } else {
          grouped.push(
            <span key={i}>
              {start} <i className="fas fa-arrow-right"></i> {end}
            </span>
          );
        }
        start = times[i];
      }
      end = times[i];
    }

    if (start === end) {
      grouped.push(start);
    } else {
      grouped.push(
        <span>
          {start} <i className="fas fa-arrow-right"></i> {end}
        </span>
      );
    }

    return grouped;
  }

  // Add state to toggle the button's visibility
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button when user scrolls down by 200px
      setShowButton(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const test = cuts;
  const [show, setShow] = useState(false);
  return (
    <>
      <BookCut show={show} setShow={setShow} />
      <Container fluid>
        {/* Existing content goes here */}
        {showButton && (
          <Button
            variant="primary"
            className="book-now-button"
            onClick={(e) => setShow(true)}
          >
            <i
              className="fa fa-cut icon-3x"
              style={{ transform: "rotate(90deg)", fontSize: "18px" }}
            ></i>{" "}
            Book Now
          </Button>
        )}
      </Container>

      <Container fluid>
        <Row>
          <Col className="position-relative p-0">
            <Image
              src={image_2}
              fluid
              style={{
                height: "800px", // Adjust height as needed
                objectFit: "cover", // Ensures image covers the area without distortion
                width: "100%", // Ensure image takes full width of the column
              }}
            />
            <div
              style={{ zIndex: 10, top: "-2rem", position: "absolute" }}
              className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center text-white p-3"
            >
              <div className="quote">The best cut in town</div>
              <div className="quote mt-2">
                Precision and style in every snip
              </div>
              <div className="quote mt-2 font-weight-bold">
                Shawn's Barber Shop
              </div>

              <div className="buttonsContainer">
                <br />
                <br />
                <Button
                  variant="primary"
                  onClick={(e) => setShow(true)}
                  style={{
                    padding: "20px 50px", // Adjust padding for size
                    fontSize: "30px", // Increase font size
                    borderRadius: "60px", // Optional: make corners rounded
                    marginTop: "30px",
                  }}
                >
                  <i
                    className="fa fa-cut icon-3x"
                    style={{ transform: "rotate(90deg)", fontSize: "40px" }}
                  ></i>{" "}
                  Book Now
                </Button>
              </div>
            </div>
            <div className="position-absolute top-0 start-0 w-100">
              <Menu />
            </div>
          </Col>
        </Row>

        <Row style={{ backgroundColor: "#9da0a6", paddingTop: "10px" }}>
          <Col lg={3}>
            <div className="container">
              <Card>
                <Card.Img variant="top" src={image_1} />
                <Card.Body style={style}>
                  <Card.Title>Elevate Your Style</Card.Title>
                  <Card.Text>
                    Experience top-notch grooming that elevates your style and
                    confidence at Shawn's Barber Shop.
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Col>
          <Col lg={3}>
            <div className="container">
              <Card>
                <Card.Img variant="top" src={image_2} />
                <Card.Body style={style}>
                  <Card.Title>Unforgettable Precision</Card.Title>
                  <Card.Text>
                    Step into a world of luxury and precision cuts that make
                    every visit unforgettable.
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Col>
          <Col lg={3}>
            <div className="container">
              <Card>
                <Card.Img variant="top" src={image_1} />
                <Card.Body style={style}>
                  <Card.Title>Tailored Grooming</Card.Title>
                  <Card.Text>
                    Transform your look with expert haircuts and premium
                    grooming services tailored for you.
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Col>
          <Col lg={3}>
            <div className="container" style={style}>
              <Card>
                <Card.Img variant="top" src={image_1} />
                <Card.Body style={style}>
                  <Card.Title>Professional Relaxation</Card.Title>
                  <Card.Text>
                    Enjoy a relaxing atmosphere and professional service that
                    keeps you looking your best.
                  </Card.Text>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
        {/* cuts table */}
        <Row className="offers-row" style={{ backgroundColor: "#ddd" }}>
          <h2 className="text-left">
            What We Offer{" "}
            {isLoadingCuts && (
              <Spinner size="md" animation="border" role="status"></Spinner>
            )}
          </h2>
          <Col className="offer-col" lg={4} mid={6} sm={12}>
            <Table className="offer-table">
              <thead>
                <tr>
                  <th colSpan={2} className="text-center">
                    Hair
                  </th>
                </tr>
                <tr>
                  <th>Style</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {cuts &&
                  cuts
                    .filter((c) => c.type === "Hair")
                    .map((c) => (
                      <tr key={c.cut_id}>
                        <td>{c.name}</td>
                        <td>{c.price}</td>
                      </tr>
                    ))}
              </tbody>
            </Table>
          </Col>
          <Col className="offer-col" lg={4} sm={12}>
            <Table className="offer-table">
              <thead>
                <tr>
                  <th colSpan={2} className="text-center">
                    Face
                  </th>
                </tr>
                <tr>
                  <th>Style</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {cuts &&
                  cuts
                    .filter((c) => c.type === "Face")
                    .map((c) => (
                      <tr key={c.cut_id}>
                        <td>{c.name}</td>
                        <td>{c.price}</td>
                      </tr>
                    ))}
              </tbody>
            </Table>
          </Col>
          <Col className="offer-col" lg={4} sm={12}>
            <Table className="offer-table">
              <thead>
                <tr>
                  <th colSpan={2} className="text-center">
                    Beard
                  </th>
                </tr>
                <tr>
                  <th>Style</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {cuts &&
                  cuts
                    .filter((c) => c.type === "Beard")
                    .map((c) => (
                      <tr key={c.cut_id}>
                        <td>{c.name}</td>
                        <td>{c.price}</td>
                      </tr>
                    ))}
              </tbody>
            </Table>
          </Col>
        </Row>

        {/* Opening days table */}
        <Row className="m-2" style={{ borderRadius: "100%" }}>
          <h2>
            Opening Days{" "}
            {isLoadingSchedules && (
              <Spinner size="md" animation="border" role="status"></Spinner>
            )}
          </h2>
          <Col>
            <Table className="offer-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Day</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {schedules &&
                  schedules.map((sch, index) => (
                    <tr key={index}>
                      <td>{sch.index}</td>
                      <td>{sch.day}</td>
                      <td>
                        <ul>
                          {groupTimeSlots(sch.time).map((range, i) => (
                            <li key={i}>{range}</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Footer />
        </Row>
      </Container>
    </>
  );
};

export default MainPage;
